import type { SingleAnswerQuestion } from '@feh/shared-ui';
import { createReducer, on } from '@ngrx/store';

import { homebatteryQuestionnaireStructure } from './homebattery-questionnaire.structure';
import {
  loadNextQuestion,
  loadPreviousQuestion,
  submitQuestionnaireAnswer,
} from './homebattery-questionnaire.actions';

export const homebatteryQuestionnaireKey = 'homebattery-questionnaire';

export type HomebatteryQuestionnaireState = {
  structure: { [key: string]: SingleAnswerQuestion };
  currentQuestion: SingleAnswerQuestion;
  answers: { [key: string]: string | boolean | null };
  history: SingleAnswerQuestion[];
};

export const initialState: HomebatteryQuestionnaireState = {
  structure: homebatteryQuestionnaireStructure,
  currentQuestion: homebatteryQuestionnaireStructure['hasSolarPanels'],
  answers: {},
  history: [],
};

export const homebatteryQuestionnaireReducer = createReducer(
  initialState,
  on(submitQuestionnaireAnswer, (state, { question, answer }) => ({
    ...state,
    answers: {
      ...state.answers,
      [question.apiKey]: answer.apiValue,
    },
  })),
  on(loadNextQuestion, (state, { question }) => {
    const history = [...state.history];
    history.push(state.currentQuestion);
    return {
      ...state,
      history,
      currentQuestion: question,
    };
  }),
  on(loadPreviousQuestion, (state) => {
    const history = [...state.history];
    const previous = history.pop();
    return previous !== undefined
      ? { ...state, currentQuestion: previous, history }
      : state;
  })
);
